import termsConditionsContent from "./content/terms-conditions.json";

export const termsConditionsMock = {
  name: "terms-and-conditions",
  layoutType: 1,
  areasList: [
    {
      id: "terms-and-conditions-1",
      name: "terms-and-conditions-content",
      componentName: "Comp:TermsConditionsPage",
      content: JSON.stringify(termsConditionsContent),
    },
  ],
};
